import { stateCrcBacking } from '$lib/states/crcBacking.svelte';
import { stateMe } from '$states/me.svelte';
import { stateTrusts } from '$states/trusts.svelte';
import { VerificationBadgeType } from '$types/verificationBadge';

export const isValidToAccessToPowerUp = () => {
  // extended members should always have access

  const user = stateMe.current;
  if (
    user?.verificationBadge === VerificationBadgeType.QUASI_VERIFIED &&
    !stateCrcBacking.current?.lbpAddress
  ) {
    return true;
  }

  // for non-extended members, check other conditions
  return !(!stateTrusts.hasReceivedOneTrust() || stateCrcBacking.current?.lbpAddress);
};
